import React, { useEffect } from 'react';
import { Row, Col } from 'antd';
import './index.css';
import DetailItem from './../../CSIComponents/DetailItem';

interface propsType {
    detailData: object | any
}

const GeneralGeneralDetail = (props: propsType) => {
    const translateBoolean = (type: string) => type === 'true' ? 'Yes' : (type === 'false' ? 'No' : '')
    const data = props?.detailData?.environmentalimpact?.general?.general || {}
    const detailData = [
        { label: 'Certification Available', value: translateBoolean(data.certavail), span: 6 },
        { label: 'Linen Reuse Program', value: translateBoolean(data.linenreuse), span: 6 },
        { label: 'Accommodates Chemical Allergies', value: translateBoolean(data.accomodateschemicalall), span: 6 },
        { span: 5 },
        { label: 'Environmental Friendly Cleaners', value: translateBoolean(data.envfriendlycleaners), span: 6 },
        { label: 'Procurement Policy', value: translateBoolean(data.procurementpolicy), span: 6 },
        { label: 'Certification Include Third Party Audits', value: translateBoolean(data.certthirdpartyaudits), span: 6 },
        { span: 5 },

        { label: 'Certification Upon Request', value: translateBoolean(data.certuponrequest), span: 6 },
        { label: 'Corporate Social Responsibility Program', value: translateBoolean(data.corporatesocialrespprog), span: 6 },
        { span: 11 },

        { label: 'Corporate Social Responsibility Program Description', value: data.corporatesocialrespprogdesc, span: 12 },
        { span: 11 },

        { label: 'Non-Carbon Emitting Measures', value: translateBoolean(data.noncarbonemittingmethods), span: 6 },
        { span: 17 },

        { label: 'Non-Carbon Emitting Measures Description', value: data.noncarbonemittingmethodsdesc, span: 12 },
        { span: 6 },
    ]
    useEffect(() => {

    }, [])

    return (
        <div>
            <Row gutter={24}>
                {detailData.map((item, i) => {
                    return (
                        <React.Fragment key={i}>
                            {
                                item.label ? <Col span={item.span} key={i} className="col-margin">
                                    <DetailItem value={item.value} label={item.label} />
                                </Col> : <Col span={item.span} key={i}></Col>
                            }
                        </React.Fragment>

                    )
                })
                }
            </Row>
        </div>
    )
}

export default GeneralGeneralDetail;



